// Tracks the most recent client-side Sentry error event ID so the bugnub can
// attach a meaningful event reference to bug reports. Sentry.lastEventId()
// returns whatever event the SDK touched last (transactions, logs, dropped
// events), which is usually not the error the user was actually hitting.
//
// Only IDs from events that survive beforeSend filtering are recorded — those
// are the ones that actually exist in Sentry.

const MAX_AGE_MS = 5 * 60 * 1000;

let lastErrorEventId: string | null = null;
let lastErrorAt = 0;

export function recordSentryErrorId(eventId: string): void {
  lastErrorEventId = eventId;
  lastErrorAt = Date.now();
}

export function getLastSentryErrorId(): string | null {
  if (!lastErrorEventId) return null;
  if (Date.now() - lastErrorAt > MAX_AGE_MS) return null;
  return lastErrorEventId;
}
